var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M74.7 100c0-13.2 10.7-23.8 23.8-23.8 13.1 0 23.8 10.7 23.8 23.8 0 13.1-10.7 23.8-23.8 23.8-13.1 0-23.8-10.7-23.8-23.8zM98.5 0C51.8 0 12.7 32 1.6 75.2c-.1.3-.1.6-.1 1 0 2.6 2.1 4.8 4.8 4.8h40.3c1.9 0 3.6-1.1 4.3-2.8 8.3-18 26.5-30.6 47.6-30.6 28.9 0 52.4 23.5 52.4 52.4s-23.5 52.4-52.4 52.4c-21.1 0-39.3-12.5-47.6-30.6-.8-1.6-2.4-2.8-4.3-2.8H6.3c-2.6 0-4.8 2.1-4.8 4.8 0 .3.1.6.1 1C12.6 168 51.8 200 98.5 200c55.2 0 100-44.8 100-100S153.7 0 98.5 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleci);
export default __webpack_public_path__ + "97120/static/media/circleci.b64589ee6d675b5ed57c108217bb9ffb.svg";
export { ForwardRef as ReactComponent };